import template from './racedayAddForm.html';
import controller from './racedayAddForm.controller';
import './racedayAddForm.scss';

let racedayAddFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    validation: '<',
    raceday: '=',
    storeFile: '&'
  },
  template,
  controller
};

export default racedayAddFormComponent;
